import React from 'react';

const PersistentMiniEpgRecordIcon = ({ type }) => {
    return (
        <img
            alt="record-icon"
            style={{ display: 'none' }}
            id={`mini-${type}-event-record-image`}
            className="mini-event-record-image"
        />
    );
};

export default PersistentMiniEpgRecordIcon;



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/PersistentMiniEpgRecordIcon.jsx